import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import { Loader } from 'semantic-ui-react';

import { Text } from './styles';
import { APPROVE_ALL_TEST_SESSIONS } from './graphql';

const ApproveAllTestersButton = ({ projectId, onRefetch }) => {
  const [approveAllTesters, { loading }] = useMutation(APPROVE_ALL_TEST_SESSIONS);

  const handleApproveTesters = async () => {
    try {
      await approveAllTesters({ variables: { projectId } });
      await onRefetch();
    } catch (err) {
      captureException('APPROVE_ALL_TESTERS_ERROR', err);
    }
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <Text onClick={handleApproveTesters}>Approve All Testers</Text>
  );
};

ApproveAllTestersButton.propTypes = {
  projectId: PropTypes.string.isRequired,
  onRefetch: PropTypes.func.isRequired,
};

export default ApproveAllTestersButton;
